'use strict';

const AncillariesGuarantee = require('./ancillaries_tracking/ancillaries_guarantees');
const AncillariesServiceOptions = require('./ancillaries_tracking/ancillaries_service_options');
const ANCILLARIES_CLASSES_ENUM = new Odigeo.Enum(['guarantees', 'serviceOptions']);

let trackHelpers = {};
module.exports = function(product) {
    if (Odigeo._.isEmpty(trackHelpers[product])) {
        switch (product) {
            case ANCILLARIES_CLASSES_ENUM.guarantees:
                trackHelpers[product] = new AncillariesGuarantee(product);
                break;
            case ANCILLARIES_CLASSES_ENUM.serviceOptions:
                trackHelpers[product] = new AncillariesServiceOptions(product);
                break;
            default:
                break;
        }
    }

    return trackHelpers[product];
};
